import { useEffect, useState, useCallback } from 'react';
import {
  getReferralUrl,
  getSingularReferralUrl,
  getIsSingularReferralLinkEnabled
} from '@cont/Settings/Referral/ReferralDetails/apiHelper';
import { localStorageAvailable } from '@utils/localStorage';
import useGetReferralInfo from './useGetReferralInfo';

const useOneLinkReferral = (options = {}, directLink) => {
  const { goalUID } = useGetReferralInfo();
  const templateId = 'u7cm';
  const [oneLinkURL, setOneLinkURL] = useState(null);
  const { referralCode } = options;
  const setLocalLink = useCallback(
    (referralLink) => {
      if (localStorageAvailable && referralLink) {
        const onelinks = JSON.parse(
          localStorage.getItem('oneReferralLinks') ?? '{}'
        );
        if (!onelinks[goalUID]) {
          onelinks[goalUID] = referralLink;
          localStorage.setItem('oneReferralLinks', JSON.stringify(onelinks));
        }
      }
    },
    [goalUID]
  );

  const getLocalLink = useCallback(() => {
    if (localStorageAvailable) {
      const onelinks = JSON.parse(
        localStorage.getItem('oneReferralLinks') ?? '{}'
      );
      return onelinks[goalUID];
    }
  }, [goalUID]);

  const getReferralLink = useCallback(
    async (goalPageLink) => {
      const payload = {
        goal_uid: goalUID
      };
      const localLink = getLocalLink();
      if (localLink) {
        setOneLinkURL(localLink);
      } else {
        let response = null;
        const isSingular = await getIsSingularReferralLinkEnabled();
        if (isSingular?.description === 'true') {
          response = await getSingularReferralUrl(payload);
        } else {
          response = await getReferralUrl(templateId, payload);
        }
        const shortLink = response?.shortlink || response?.shortLink;
        setOneLinkURL(shortLink || goalPageLink);
        setLocalLink(shortLink);
      }
    },
    [goalUID, getLocalLink, setLocalLink]
  );

  useEffect(() => {
    if (!goalUID) return;
    const goalPageLink = `https://unacademy.com/goal/-/${goalUID}/subscribe?referral_code=${referralCode}&show_pricing=true`;
    if (directLink) return goalPageLink;
    getReferralLink(goalPageLink);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [goalUID, referralCode]);

  return oneLinkURL;
};

export default useOneLinkReferral;
